/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Convert an enum-style identifier to a title-style string (words capitalized).
 */
export function enumToString(str: string, joinChar = ' '): string {
  if (str) {
    const words = str.toLowerCase().split('_')

    const capitalizedWords = words.map((word) => {
      if (!word) {
        return word
      }
      return word.charAt(0).toUpperCase() + word.slice(1)
    })

    return capitalizedWords.join(joinChar)
  }
  return str
}
